module.exports = __webpack_public_path__ + "static/media/img06.33e18b8f.png";